"use strict";

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.for-each");

var _themeSections = require("@shopify/theme-sections");

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

var _utils = require("../helpers/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Section: FAQs section
 * ------------------------------------------------------------------------------
 * FAQs accordion events
 *
 * @namespace faqs
 */

/**
 * DOM selectors.
 */


var selectors = {
  item: '[js-faqs="item"]',
  header: '[js-faqs="header"]'
};
/**
 * Executes on page load as well as Theme Editor `section:load` events.
 * @param {string} container - Selector for the section container DOM element.
 */

(0, _themeSections.register)('faqs', {
  /**
  * Cache selectors.
  * - Define necessary variables and make available for component use.
  */
  cacheSelectors: function cacheSelectors() {
    var item = "[data-section-id=\"".concat(this.id, "\"] ").concat(selectors.item);
    var header = "[data-section-id=\"".concat(this.id, "\"] ").concat(selectors.header);
    this.cache = {
      item: item,
      header: header
    };
    this.nodeSelectors = {
      accordionItem: document.querySelectorAll(this.cache.item),
      accordionHeader: document.querySelectorAll(this.cache.header)
    };
  },

  /**
  * Event Listeners.
  * - Event listeners for click actions
  */
  eventListeners: function eventListeners() {
    var _this = this;

    this.nodeSelectors.accordionHeader.forEach(function (element, index) {
      (0, _utils.on)('click', element, function () {
        return _this.toggleAccordion(index);
      });
    });
  },

  /**
  * toggleAccordion.
  * - Function to toggle accordion answers.
  */
  toggleAccordion: function toggleAccordion(index) {
    if (this.nodeSelectors.accordionItem[index]) {
      this.nodeSelectors.accordionItem[index].classList.toggle(_cssClasses["default"].active);
    }
  },

  /**
  * Construct new carousel on `section:load`.
  */
  onLoad: function onLoad() {
    this.cacheSelectors();
    this.eventListeners();
  }
});